import React from "react";
import { useSelector } from "react-redux";
import { Loader } from "semantic-ui-react";

const LoadingIcon = ({ children, commonLoading, size }) => {
  const loadingStatus = useSelector((state) => state.isLoaderStatus);

  return loadingStatus || commonLoading ? (
    <div>
      <Loader
        className="!text-main-color"
        active
        size={size ? size : "mini"}
        inline="centered"
      >
        {/* {children} */}
      </Loader>
    </div>
  ) : (
    children
  );
};

export default LoadingIcon;
